import { render } from "./Processor.vue?vue&type=template&id=4903f6b4"
import script from "./Processor.vue?vue&type=script&lang=ts"
export * from "./Processor.vue?vue&type=script&lang=ts"
script.render = render

export default script
import QPage from 'quasar/src/components/page/QPage.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage});
